export default {
  setDeviceList (state, data) {
    state.deviceList = data;
  },
  deleteIdFromDeviceList (state, idToDelete) {
    const deleteIndex = state.deviceList.findIndex(v => v === idToDelete);
    state.deviceList.splice(deleteIndex, 1);
  }
};